<template>
    <component :is="layout" />
</template>

<script>
import DefaultLayout from '@/layouts/default';
import EmptyLayout from '@/layouts/empty';

export default {
    name: 'App',

    components: { DefaultLayout, EmptyLayout },

    computed: {
        layout() {
            return this.$route.meta.layout === 'empty' ? 'EmptyLayout' : 'DefaultLayout';
        },
    },

    created() {
        window.addEventListener('message', this.onMessageEvent);

        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('message', this.onMessageEvent);
        });
    },

    methods: {
        async onMessageEvent(ev) {
            if (ev.data?.action === 'timeDiff') {
                this.$store.commit('setTimeDiff', ev.data.data);
            }
            if (ev.data?.action === 'email-updated') {
                const email = ev.data.data.email;
                this.$store.commit('setUserEmail', ev.data.data.email);
                if (window.parent) {
                    await window.parent.postMessage(
                        {
                            action: 'email-updated',
                            data: {
                                email,
                            },
                        },
                        '*',
                    );
                }
            }
        },
    },
};
</script>

<style lang="scss">
.progress-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
